import { observer } from "mobx-react";
import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import { t, translate, Tracking } from "restaumatic-client";
import debounce from "../utils/debounce";
import { showModal, switchModals, isModalClosed } from "../utils/Modals";
import PreactModal, { ModalHeader } from "./PreactModal";
import { FULFILLMENT_ADDRESS_MODAL_ID } from "../views/Menu/FulfillmentSettings";
import FieldTests from "../utils/FieldTests";
import { freeDeliveryWithoutAdressEqualSplit } from "../utils/FieldTests/experiments/FreeDeliveryWithoutAdressEqualSplit";
const BOTTOM_SHEET_ID = "free-delivery";
const SHOW_DELAY = 600;
function FreeDeliveryWithoutAddressBottomSheet(props) {
    const { freeDeliveryWithoutAddressBottomSheet, triggeringAction, triggeringElementId, } = props;
    const { shouldBeOpened, textMessage, freeDeliveryPrice } = freeDeliveryWithoutAddressBottomSheet;
    const focusedElementBeforeOpen = useRef(undefined);
    // NOTICE: `!isModalClosed` is a HACK for iOS to prevent opening modal while other modal (eg. Cart) is opened and body is scrollable... (this is needed because iOS does not support `overflow: hidden` on body element).
    const isDisabled = !shouldBeOpened || !isModalClosed();
    const titleId = `${BOTTOM_SHEET_ID}-title`;
    const openFreeDeliveryBottomSheet = () => {
        setTimeout(() => {
            if (!isModalClosed()) {
                return;
            }
            // A/B Test
            FieldTests.apply(freeDeliveryWithoutAdressEqualSplit);
            const variant = FieldTests.getVariant(freeDeliveryWithoutAdressEqualSplit);
            if (variant === "Control") {
                return;
            }
            // Find currently focused element to restore focus after
            // interrupting user interaction (closing BS or address modal)
            const lastFocusedElement = document.activeElement;
            // Prevent focus restoration to links elements that has been clicked because it will cause jump to link and confuse user
            if (lastFocusedElement instanceof HTMLElement &&
                lastFocusedElement.tagName !== "A") {
                focusedElementBeforeOpen.current = lastFocusedElement;
            }
            else {
                focusedElementBeforeOpen.current = document.body;
            }
            void showModal(BOTTOM_SHEET_ID, focusedElementBeforeOpen.current);
            Tracking.trackEvent({
                tag: "FreeDeliveryBottomSheetOpened",
                contents: {
                    price: freeDeliveryPrice.asNumber,
                },
            });
        }, SHOW_DELAY);
    };
    useScrollTrigger(isDisabled ? "disabled" : triggeringAction, triggeringElementId, openFreeDeliveryBottomSheet);
    const openAddressModal = () => {
        Tracking.trackEvent({
            tag: "FreeDeliveryBottomSheetCtaClicked",
            contents: {
                price: freeDeliveryPrice.asNumber,
            },
        });
        void switchModals(BOTTOM_SHEET_ID, FULFILLMENT_ADDRESS_MODAL_ID, focusedElementBeforeOpen.current);
    };
    const handleHidden = () => {
        freeDeliveryWithoutAddressBottomSheet.markAsClosed();
        Tracking.trackEvent({
            tag: "FreeDeliveryBottomSheetClosed",
            contents: {
                price: freeDeliveryPrice.asNumber,
            },
        });
    };
    return (h(PreactModal, { id: BOTTOM_SHEET_ID, titleId: titleId, onHidden: handleHidden, modalClass: "modal-dialog--bottomsheet", dataFieldId: "freeDeliveryWithoutAddressBottomSheet" },
        h(ModalHeader, { titleId: titleId, title: translate(t.delivery.free_delivery) }),
        h("div", { class: "modal-body" },
            h("p", { class: "u-mb3" }, textMessage)),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { class: "btn btn-primary btn-block", onClick: openAddressModal }, translate(t.delivery.provide_address)))));
}
// Custom hook to separate scroll detection logic
function useScrollTrigger(mode, elementId, callback) {
    useEffect(() => {
        if (mode === "disabled") {
            return;
        }
        const element = document.getElementById(elementId);
        if (element === null) {
            console.warn(`Scroll trigger: Element with ID "${elementId}" not found.`);
            return;
        }
        const handleScroll = debounce(() => {
            const rect = element.getBoundingClientRect();
            const runAndRemoveListener = () => {
                callback();
                window.removeEventListener("scroll", handleScroll);
            };
            switch (mode) {
                case "scrollOver": {
                    // Check if the element is scrolled over the top of the viewport
                    if (rect.bottom < 0) {
                        runAndRemoveListener();
                    }
                    break;
                }
                case "scrollInto": {
                    // Check if the element is in the top third of the viewport
                    if (rect.top < window.innerHeight / 3) {
                        runAndRemoveListener();
                    }
                    break;
                }
            }
        }, 100);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [mode, elementId, callback]);
}
export default observer(FreeDeliveryWithoutAddressBottomSheet);
